import { render } from "./AppTableLink.vue?vue&type=template&id=6529933f&scoped=true"
import script from "./AppTableLink.vue?vue&type=script&lang=js"
export * from "./AppTableLink.vue?vue&type=script&lang=js"

import "./AppTableLink.vue?vue&type=style&index=0&id=6529933f&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6529933f"]])

export default __exports__